import { createClass as _createClass } from "\0rollupPluginModLoBabelHelpers.js";
import { assertThisInitialized as _assertThisInitialized } from "\0rollupPluginModLoBabelHelpers.js";
import { inheritsLoose as _inheritsLoose } from "\0rollupPluginModLoBabelHelpers.js";
import { defineProperty as _defineProperty } from "\0rollupPluginModLoBabelHelpers.js";

var _dec, _class, _temp;

import { cclegacy as _cclegacy } from "cc";

_cclegacy._RF.push({}, "faa98ejrm5CZKCOhBjwc5Lz", "Dove", undefined);

import { _decorator, Component, tween, v3, ParticleSystem } from 'cc';
import { App } from './common/manager/App';
import { E_PoolType } from './common/manager/PoolManager';
var ccclass = _decorator.ccclass,
    property = _decorator.property;
export var Dove = (_dec = ccclass('Dove'), _dec(_class = (_temp = /*#__PURE__*/function (_Component) {
  _inheritsLoose(Dove, _Component);

  function Dove() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _Component.call.apply(_Component, [this].concat(args)) || this;

    _defineProperty(_assertThisInitialized(_this), "_isDie", false);

    _defineProperty(_assertThisInitialized(_this), "_attachLight", null);

    return _this;
  }

  var _proto = Dove.prototype;

  _proto.init = function init() {
    this.isDie = false;
    this.node.angle = 0;
    var n_light = App.PoolMgr.getItem(E_PoolType.PS_Dove);
    n_light.parent = this.node.parent;
    var pos_cur = v3(this.node.worldPosition);
    n_light.setWorldPosition(v3(pos_cur.x, pos_cur.y - 0.3, pos_cur.z));
    var ps_ligth = n_light.getComponent(ParticleSystem);
    ps_ligth.clear();
    ps_ligth.loop = true;
    ps_ligth.velocityOvertimeModule.enable = false;
    ps_ligth.sizeOvertimeModule.enable = false;
    ps_ligth.play();
    this._attachLight = n_light;
  };

  _proto.start = function start() {// [3]
    // this.scheduleOnce(() => {
    //     this.init();
    // }, 2);
  };

  _proto.dieAmn = function dieAmn() {
    var _this2 = this;

    var ps_ligth = this._attachLight.getComponent(ParticleSystem); // ps_ligth.clear();
    // ps_ligth.time = 0;


    ps_ligth.loop = false;
    ps_ligth.velocityOvertimeModule.enable = true;
    ps_ligth.sizeOvertimeModule.enable = true;
    ps_ligth.play();
    tween(this._attachLight).delay(2).call(function () {
      App.PoolMgr.returnItem(_this2._attachLight);
    }).start();
    tween(this.node).to(0.1, {
      angle: -90
    }).call(function () {
      App.PoolMgr.returnItem(_this2.node);
    }).start();
  } // update (deltaTime: number) {
  //     // [4]
  // }
  ;

  _createClass(Dove, [{
    key: "isDie",
    get: function get() {
      return this._isDie;
    },
    set: function set(v) {
      this._isDie = v;

      if (v) {
        this.dieAmn();
      }
    }
  }]);

  return Dove;
}(Component), _temp)) || _class);
/**
 * [1] Class member could be defined like this.
 * [2] Use `property` decorator if your want the member to be serializable.
 * [3] Your initialization goes here.
 * [4] Your update function goes here.
 *
 * Learn more about scripting: https://docs.cocos.com/creator/3.0/manual/en/scripting/
 * Learn more about CCClass: https://docs.cocos.com/creator/3.0/manual/en/scripting/ccclass.html
 * Learn more about life-cycle callbacks: https://docs.cocos.com/creator/3.0/manual/en/scripting/life-cycle-callbacks.html
 */

_cclegacy._RF.pop();